export default __webpack_public_path__ + "static/media/alumini (4).09311da1.JPG";